// extracted by mini-css-extract-plugin
export var fillRed = "hellotext-module--fillRed--jreyA";
export var fillWhite = "hellotext-module--fillWhite--95F0w";
export var lineAnim = "hellotext-module--line-anim--BNOz0";
export var text = "hellotext-module--text--ue17Z";
export var textEnd = "hellotext-module--textEnd--OUBXH";